import '../field-description-table.css';

const CustomerSupportGuidanceFieldDescriptions = (
  <>
    <table className={'table'}>
      <thead>
        <tr>
          <th className={'field-description'}>Field</th>
          <th className={'field-description'}>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={'field-name'}>Scenario Description</td>
          <td className={'field-description'}>Brief description relating to the accuracy of the input address.</td>
        </tr>
        <tr>
          <td className={'field-name'}>Customer Support Impact</td>
          <td className={'field-description'}>Describes the type of call the agent could receive if the information for the input address isn’t corrected and the bad address is used in a mailing.</td>
        </tr>
        <tr>
          <td className={'field-name'}>Simple Explanation</td>
          <td className={'field-description'}>Easy-to-understand explanation as to why the input address is invalid.</td>
        </tr>
        <tr>
          <td className={'field-name'}>Agent&#39;s Next Steps</td>
          <td className={'field-description'}>Action items for the agent to take with the caller.</td>
        </tr>
        <tr>
          <td className={'field-name'}>Sample Questions</td>
          <td className={'field-description'}>Questions the agent can ask the caller in order to correct or confirm the address.</td>
        </tr>
        <tr>
          <td className={'field-name'}>Additional Address Issues</td>
          <td className={'field-description'}>If an address has more than one issue, the main one will be detailed above and subsequent issues will be described here.</td>
        </tr>
      </tbody>
    </table>
  </>
);

export default CustomerSupportGuidanceFieldDescriptions;
